<template>
    <div id="screenshot-container">
        <div class="overlay"></div>
        <div class="print-preview">
            <a v-if="imageData" id="print-image-href" :href="imageData" :download="fileName">
                <img :src="imageData" alt="" />
            </a>
            <div v-else class="d-flex justify-content-center align-items-center w-100 h-100 p-4">
                <h5>{{ $t('keyword163') }}</h5>
                <b-spinner label="Spinning" small variant="secondary"></b-spinner>
            </div>
        </div>
        <div v-if="imageData" class="controls d-flex flex-column ml-3">
            <ci-button
                class="mb-2"
                @click="requestClose"
                type="black"
                :leftIcon="{ name: 'times', scale: '1', color: 'var(--light)' }"
                :text="$t('button_text76')"
            />

            <ci-button @click="download" :leftIcon="{ name: 'download', scale: '1', color: 'var(--light)' }" text="Download" />
        </div>
    </div>
</template>
<script>
/**
 * @param {String} fileName - The download file name
 * @param {String} imageData - Base64 String
 *
 * @event close
 */
export default {
    name: 'ScreenshotPreview',
    props: {
        fileName: String,
        imageData: String,
    },
    methods: {
        download() {
            document.querySelector('#print-image-href').click()
        },
        requestClose() {
            this.$emit('close')
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/360Viewer/UI/screenshot-preview.scss';
</style>
